export default {
  props: {
    description: {
      type: String,
    },
    name: {
      type: String,
    },
    jobFunction: {
      type: String,
    },
    theme: {
      type: String,
    },
    image: {
      type: Object,
    },
  },
}
